module.exports = __webpack_public_path__ + "img/outbox.185a4254.png";